const TONES = {
  new: "bg-amber-500/10 text-amber-700 border-amber-500/20",
  running: "bg-amber-500/10 text-amber-700 border-amber-500/20",
  scheduled: "bg-indigo-500/10 text-indigo-700 border-indigo-500/20",
  cancelled: "bg-slate-500/10 text-slate-600 border-slate-500/20",
  sent: "bg-emerald-500/10 text-emerald-700 border-emerald-500/20",
  completed: "bg-emerald-500/10 text-emerald-700 border-emerald-500/20",
  failed: "bg-rose-500/10 text-rose-700 border-rose-500/20",
  interrupted: "bg-rose-500/10 text-rose-700 border-rose-500/20",
  unsubscribed: "bg-slate-500/10 text-slate-600 border-slate-500/20",
  delivered: "bg-emerald-500/10 text-emerald-700 border-emerald-500/20",
  delivery_delayed: "bg-amber-500/10 text-amber-700 border-amber-500/20",
  bounced: "bg-rose-500/10 text-rose-700 border-rose-500/20",
  complained: "bg-rose-500/10 text-rose-700 border-rose-500/20",
};

export function StatusBadge({ status, testId }) {
  return (
    <span data-testid={testId} className={`inline-flex text-[11px] font-mono px-2 py-0.5 rounded-full border ${TONES[status] || TONES.unsubscribed}`}>
      {status === "new" ? "not sent" : status === "delivery_delayed" ? "delayed" : status === "complained" ? "spam report" : status}
    </span>
  );
}
